import axios from "axios";

export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        Authorization: `Bearer ${API_TOKEN}`,
        'Content-Type': 'application/json',
    },
});

// Generic GET request
export const fetchData = async (endpoint, params = {}) => {
  try {
    const response = await api.get(endpoint, { params });
    return response.data.data;
  } catch (error) {
    console.error('GET error:', error);
    throw error;
  }
};

// Generic POST request
export const postData = async (endpoint, data = {}) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('POST error:', error);
    throw error;
  }
};

// Generic PUT request
export const putData = async (endpoint, data = {}) => {
  try {
    const response = await api.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error('PUT error:', error);
    throw error;
  }
};

// Generic DELETE request
export const deleteData = async (endpoint) => {
  try {
    const response = await api.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error('DELETE error:', error);
    throw error;
  }
};

export default api;